import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { Grid, Typography, Button, Box } from '@mui/material';

import Language from '../Language/Language';
import Panel from '../../Elements/Panel';
import { blogPosts } from '../../content/blog';
import { COLOR_SECONDARY, COLOR_TEXT_MUTED } from '../../constants/styleValues';

const componentContent = {
    language_DE: {
        heading: 'Blog',
        intro: 'Ideen und Impulse rund um Socializing im Team - hybrides Arbeiten, mehrsprachige Teams und die ersten Tage im neuen Job.',
        readMore: 'Weiterlesen',
        backHome: 'Zurück zur Startseite'
    },
    language_EN: {
        heading: 'Blog',
        intro: 'Ideas and inspiration around team socializing - hybrid work, multilingual teams, and the first days in a new job.',
        readMore: 'Read more',
        backHome: 'Back to homepage'
    },
    language_FR: {
        heading: 'Blog',
        intro: 'Idées et inspirations autour du socializing en équipe - travail hybride, équipes multilingues et premiers jours dans un nouvel emploi.',
        readMore: 'Lire la suite',
        backHome: 'Retour à l\'accueil'
    }
}

const BlogList = () => {
    const selectedLanguage = useSelector((state) => state.Language);
    const content = componentContent[selectedLanguage];

    return (
        <div>
            <Helmet>
                <title>Blog - Multiplayer Quiz</title>
                <meta name="description" content="Ideas and inspiration around team socializing: hybrid afterwork, multilingual teams, and onboarding new colleagues." />
                <link rel="canonical" href="https://multiplayer-quiz.com/blog" />
            </Helmet>

            <Grid container justifyContent="center" textAlign="center" sx={{px: {xs: 2, sm: 3}, pt: 3}}>
                <Language />
            </Grid>

            <Grid container justifyContent="center" textAlign="center" sx={{px: {xs: 2, sm: 3}, pb: 6}}>
                <Grid container maxWidth="md" justifyContent="center" textAlign="center" spacing={1}>

                    <Grid item xs={12} sx={{mt: 2, mb: 1}}>
                        <Typography variant="h1">{content.heading}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{mb: 4}}>
                        <Typography variant="body1" sx={{color: COLOR_TEXT_MUTED, maxWidth: '640px', margin: '0 auto'}}>
                            {content.intro}
                        </Typography>
                    </Grid>

                    {blogPosts.map((post) => {
                        const postContent = post.translations[selectedLanguage] || post.translations.language_EN;
                        return (
                            <Grid item xs={12} key={post.slug} sx={{mb: 2}}>
                                <Panel sx={{p: 3, textAlign: 'left'}}>
                                    <Box sx={{display: 'flex', gap: '10px', alignItems: 'center', mb: 1, flexWrap: 'wrap'}}>
                                        <Typography variant="caption" sx={{
                                            color: COLOR_SECONDARY, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em'
                                        }}>
                                            {postContent.categoryLabel}
                                        </Typography>
                                        <Typography variant="caption" sx={{color: COLOR_TEXT_MUTED}}>
                                            {new Date(post.publishedDate).toLocaleDateString(selectedLanguage === 'language_DE' ? 'de-DE' : selectedLanguage === 'language_FR' ? 'fr-FR' : 'en-US')}
                                        </Typography>
                                    </Box>
                                    <Typography variant="h3" sx={{mb: 1}}>{postContent.title}</Typography>
                                    <Typography variant="body2" sx={{color: COLOR_TEXT_MUTED, mb: 2}}>{postContent.excerpt}</Typography>
                                    <Button variant="outlined" size="small" href={`/blog/${post.slug}`}>{content.readMore}</Button>
                                </Panel>
                            </Grid>
                        );
                    })}

                    <Grid item xs={12} sx={{mt: 3}}>
                        <Button variant='text' href="/" sx={{color: COLOR_TEXT_MUTED}}>{content.backHome}</Button>
                    </Grid>

                </Grid>
            </Grid>
        </div>
    );
}

export default BlogList;
